export default class SmartphoneDestroyEvent {
    constructor(type) {
        this.type = type;
    }
}

SmartphoneDestroyEvent.PERFORM = "SmartphoneDestroyEvent.PERFORM";